var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMock = function SvgMock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 176,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1253_1260)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 176,
    rx: 12,
    fill: "var(--surface-container-low)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 176,
    fill: "url(#paint0_radial_1253_1260)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1253_1260)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 64,
    height: 64,
    rx: 4,
    fill: "#CCA057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6671 49.7778C73.1439 43.4884 68.4449 38.2222 59.556 38.2222C51.556 38.2222 49.7504 40 47.0838 41.7778C45.7607 42.6598 43.556 45.9259 43.556 47.1111V50.6667C43.556 51.3778 40.0004 53.3333 38.2227 54.2222C37.3338 56 40.0004 56 40.0004 56.8889C39.1115 57.7778 39.1115 57.7778 38.2227 57.7778C37.5115 58.4889 38.2227 59.8519 39.1115 60.4445C38.8152 60.4445 37.3338 60.6222 37.3338 61.3333C38.2226 62.2222 38.2226 62.2222 38.2227 63.111V63.1111C38.2227 64 36.7071 66.7977 38.2227 67.5556C40.0004 68.4445 46.2227 69.3333 48.8893 70.2222C51.556 71.1111 52.4449 76.4445 51.556 80.8889C50.8449 84.4445 46.519 88.2963 44.4449 89.7778H73.7782C73.7782 86.2222 68.4449 78.2222 67.556 76.4445C66.6671 74.6667 65.7782 71.1111 65.7782 68.4445C65.7782 66.6667 71.056 63.1111 72.8615 58.6667L72.8777 58.6829C73.7615 59.5665 74.6667 60.4715 74.6667 64.8889C74.6667 69.3333 72.8889 76.4445 73.7782 80.8889C74.7549 85.7699 75.5555 88 75.5555 89.7778H81.7778C80.8889 87.1111 80.0004 88 78.6671 80.8889C77.3566 73.8996 79.7296 67.5247 79.1111 61.3333C78.6671 56.8889 75.5282 53.3333 74.6671 49.7778Z",
    fill: "url(#paint1_linear_1253_1260)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 100,
    width: 53,
    height: 6,
    rx: 3,
    fill: "var(--on-surface-var)",
    fillOpacity: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 24,
    y: 110,
    width: 34,
    height: 6,
    rx: 3,
    fill: "var(--on-surface-var)",
    fillOpacity: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 16,
    width: 15,
    height: 6,
    rx: 2,
    fill: "var(--on-surface)",
    fillOpacity: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 16,
    width: 15,
    height: 6,
    rx: 2,
    fill: "var(--on-surface)",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 16,
    width: 15,
    height: 6,
    rx: 2,
    fill: "var(--on-surface)",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 16,
    width: 15,
    height: 6,
    rx: 2,
    fill: "var(--on-surface)",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 38,
    width: 72,
    height: 24.5,
    rx: 4,
    fill: "var(--surface-container-high)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 70.5,
    width: 72,
    height: 24.5,
    rx: 4,
    fill: "var(--surface-container-high)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 103,
    width: 72,
    height: 24.5,
    rx: 4,
    fill: "var(--surface-container-high)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 135.5,
    width: 72,
    height: 24.5,
    rx: 4,
    fill: "var(--surface-container-high)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 295,
    height: 175,
    rx: 11.5,
    stroke: "var(--on-surface)",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1253_1260",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96 240.5) rotate(-90) scale(240.5 311.749)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411648,
    stopColor: "#482F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB9F57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1253_1260",
    x1: 68.4444,
    y1: 59.5556,
    x2: 45.3333,
    y2: 79.1111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31227
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#523527"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1253_1260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 176,
    rx: 12,
    fill: "var(--surface-container-high)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1253_1260"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 64,
    height: 64,
    rx: 4,
    fill: "var(--surface-container-high)"
  })))));
};
export default SvgMock;